<template>
  <div class="vue-app full-height">
    <div v-if="preloading" class="v-preloading full-height">

    </div>
    <div v-else class="full-height">
      <the-subheader v-if="subheaderNeeded"></the-subheader>
      <router-view v-if="isLoggedIn"></router-view>
      <div v-else><p>{{loc('loggedOut')}}</p></div>
    </div>
    <notifications group="notification" position="top center" :max="3">
      <template slot="body" slot-scope="props">
        <div class="v-notification">
          <div class="v-notification__content">
            <div class="v-notification__title h3">
              {{props.item.title}}
            </div>
            <div class="v-notification__text"
                 v-html="props.item.text"></div>
            <div class="v-notification__close"
                @click="props.close">
              X
            </div>
          </div>
        </div>
      </template>
    </notifications>
  </div>
</template>

<script>

import $ from 'jquery';

export default {
  mounted: function () {
  },
  created: async function () {
    const app = this;
    const jobs = [];

    // Get language from <html> tag
    const lang = document.documentElement.getAttribute('lang');
    app.$store.commit('setLanguage', lang);

    // If subheader is found, we need to store the info, so we don't render it again
    const $subheader = $('.js-subheader');
    if($subheader.length) {
      app.$store.commit('setSubheaderFound', true);
    }

    // Get localization
    jobs.push(app.$store.dispatch('getLocalization'));

    // Get user info if it is needed by this particular app
    if(this.$store.state.needsLoggingIn) {
      jobs.push(app.$store.dispatch('getCurrentUser'));
    }

    await Promise.all(jobs);

    app.$store.commit('setPreloadingStatus', false);
  },
  computed: {
    subheaderNeeded() {
      return !this.$store.state.subheaderFound;
    },
    isLoggedIn() {
      return !this.$store.state.needsLoggingIn || this.$store.state.loggedIn;
    },
    preloading() {
      return this.$store.state.preloading;
    },
    notificationsQueue() {
      return this.$store.state.notificationsQueue;
    }
  },
  watch: {
    notificationsQueue: {
      handler: function (queue) {
        let queueTop = queue[queue.length - 1]

        if(typeof queueTop === 'undefined') {
          return;
        }

        this.$notify({
          title: queueTop,
          group: 'notification',
          duration: 3000
        })
      },
      immediate: true,
      deep: true
    }
  }
}
</script>
